/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import useToggle from "./useToggle";

type DialogName<T extends string> = T;

export default function useOpen<T extends string>(...dialogNames: DialogName<T>[]) {
    const { isOn, on, off } = useToggle(...dialogNames);
    return {
        isOpen(dialogName: DialogName<T>) {
            return isOn(dialogName);
        },

        open(dialogName: DialogName<T>) {
            on(dialogName);
        },

        close(dialogName: DialogName<T>) {
            off(dialogName);
        }
    };
}